<template>
  <a-modal
      title="订单详情"
      :visible="visible"
      @cancel="onCancel"
      :footer="null"
      :width="844"
  >
    <div class="content-bar">
      <Title title="商品信息" class="custom-title"></Title>
      <div class="mode-content">
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">商品序号</div>
            <div class="modular-value">
              {{formData.gid}}
            </div>
          </div>
          <div class="mode-col">
            <div class="modular-label">商品名称</div>
            <div class="modular-value">
              {{formData.title}}
            </div>
          </div>
        </div>
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">平台</div>
            <div class="modular-value">
              {{formData.pvd_str}}
            </div>
          </div>
        </div>
      </div>
      <Title title="订单信息" class="custom-title"></Title>
      <div class="mode-content">
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">补贴金额</div>
            <div class="modular-value">
              {{formData.subsidy_price?`¥${formData.subsidy_price}`:'-'}}
            </div>
          </div>
          <div class="mode-col">
            <div class="modular-label">服务费</div>
            <div class="modular-value" style="color: red">{{formData.fee?`¥${formData.fee}`:'-'}}</div>
          </div>
        </div>
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">订单状态</div>
            <div class="modular-value">{{formData.state_str}}</div>
          </div>
          <div class="mode-col">
            <div class="modular-label">结算状态</div>
            <div class="modular-value">{{formData.settle_state}}</div>
          </div>
        </div>
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">创建时间</div>
            <div class="modular-value">{{formData.time}}</div>
          </div>
          <div class="mode-col">
            <div class="modular-label">积分扣除时间</div>
            <div class="modular-value">{{formData.deduct_time}}</div>
          </div>
        </div>
        <div class="mode-bar">
          <div class="mode-col">
            <div class="modular-label">付款金额</div>
            <div class="modular-value">
              {{formData.price?`¥${formData.price}`:'-'}}
            </div>
          </div>
          <div class="mode-col">
            <div class="modular-label">订单号</div>
            <div class="modular-value">
              {{formData.oid?`${formData.oid}`:'-'}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>
<script>
import Title from "@/components/Title";
export default {
  components: {Title},
  data() {
    return {
      visible: false,
      formData: {
      }
    }
  },
  methods: {
    show(row) {
      this.formData = {...row}
      this.visible = true
    },
    onCancel() {
      this.visible = false
      this.formData.content = ''
      this.formData.pvd = 'tikTok'
      this.$emit('onCancel')
    },
    onReset() {
      this.formData.content = ''
    }
  },

}
</script>

<style scoped lang="scss">
.content-bar {
  padding-left: 5%;
  padding-right: 5%;
}

.custom-title {
  margin-bottom: 25px;
  font-size: 16px;
}



.d-sb {
  display: flex;
  justify-content: space-between;
}


.mode-content {
  margin-bottom: 20px;
}

.mode-bar {
  display: flex;
  justify-content: space-between;

  .mode-col {
    display: flex;
    margin-bottom: 16px;
    flex: 1;

    .modular-label {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      width: 90px;
      text-align: right;
    }

    .modular-value {
      font-size: 14px;
      padding-left: 12px;
      font-weight: 400;
      color: #999999;
      flex: 1;
    }
  }
}
</style>
